import {
  REQUEST_TRIPS,
  RECEIVE_TRIPS,
  REQUEST_RELATED_TRIPS,
  RECEIVE_RELATED_TRIPS,
  REQUEST_ADDITIONAL_TRIPS,
  RECEIVE_ADDITIONAL_TRIPS,
  SET_TRIPS_OFFSET,
  SET_ACTIVE_TRIP_POPUP,
  TOGGLE_ACTIVE_TRIP_POPUP,
  SET_TRIP_VEHICLE_FILTER,
  SET_TRIP_SORT_FILTER,
  TOGGLE_SHOW_ALL_TRIPS,
  RECEIVE_FEATURED_PROMOS,
  RECEIVE_HOMEPAGE_BANNERS,
  TOGGLE_SELECT_BYOR
} from '../constants/actionTypes';

import {
  TRIPS_PER_REQUEST,
  INITIAL_TRIPS_OFFSET,
  sortFilters
} from '../constants';

import { shuffle } from 'lodash';

const INITIAL_STATE = {
  trips: [],
  relatedTrips: [],
  totalTrips: 0,
  vehicleFilter: 'All vehicles',
  sortFilter: sortFilters[0],
  showAllTrips: false,
  limit: TRIPS_PER_REQUEST,
  offset: INITIAL_TRIPS_OFFSET,
  activeTripId: null,
  showPopUp: false,
  loading: true,
  loadingRelated: true,
  loadingMore: false,
  hasBYOC: false,
  hasBYOR: false,
  featuredPromos: [],
  homepageBanners: []
};

function tripReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REQUEST_TRIPS: {
      return { ...state, loading: true };
    }
    case RECEIVE_TRIPS: {
      return {
        ...state,
        trips: shuffle(action.trips),
        totalTrips: action.total,
        // check if there are any BYOC trips to decide whether to show BYOC note
        hasBYOC: action.trips.find(trip => trip.is_own_vehicle) !== undefined,
        hasBYOR: action.trips.find(trip => trip.byor) !== undefined,
        // offset: state.offset + state.limit,
        loading: false
      };
    }
    case RECEIVE_FEATURED_PROMOS: {
      return {
        ...state,
        featuredPromos: action.featuredPromos
      };
    }
    case RECEIVE_HOMEPAGE_BANNERS: {
      return {
        ...state,
        homepageBanners: action.homepageBanners
      };
    }
    case REQUEST_ADDITIONAL_TRIPS: {
      return { ...state, loadingMore: true };
    }
    case RECEIVE_ADDITIONAL_TRIPS: {
      return {
        ...state,
        trips: [...state.trips, ...action.trips],
        totalTrips: action.total,
        offset: state.offset + state.limit,
        loadingMore: false
      };
    }
    case REQUEST_RELATED_TRIPS: {
      return { ...state, loadingRelated: true };
    }
    case RECEIVE_RELATED_TRIPS: {
      return {
        ...state,
        relatedTrips: action.trips,
        loadingRelated: false
      };
    }
    case SET_TRIPS_OFFSET: {
      return {
        ...state,
        offset: action.offset
      };
    }
    case SET_ACTIVE_TRIP_POPUP: {
      return {
        ...state,
        activeTripId: action.id
      };
    }
    case TOGGLE_ACTIVE_TRIP_POPUP: {
      return {
        ...state,
        showPopUp: action.show
      };
    }
    case SET_TRIP_VEHICLE_FILTER: {
      return {
        ...state,
        vehicleFilter: action.vehicle
      };
    }
    case SET_TRIP_SORT_FILTER: {
      return {
        ...state,
        sortFilter: action.sortFilter,
        showAllTrips: true
      };
    }
    case TOGGLE_SHOW_ALL_TRIPS: {
      return {
        ...state,
        showAllTrips: action.show
      };
    }

    default:
      return state;
  }
}

export default tripReducer;
